import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {"display":"block"},
  viewBox: "0 0 16.667 16.667"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "var(--fill-0, #AFB3B3)",
      d: "M8.333 16.667A8.333 8.333 0 1 1 8.333 0a8.333 8.333 0 0 1 0 16.667m0-9.512L5.977 4.798l-1.18 1.179 2.358 2.356-2.357 2.357 1.179 1.18 2.356-2.358 2.357 2.357 1.18-1.179-2.358-2.357 2.357-2.356-1.179-1.18z"
    }, null, -1)
  ]))]))
}
export default { render: render }